<template>
  <div id="refund_application">
    <div
      id="Inner_text"
      class="container"
    >
      <div class="row white-color">
        <!-- 標題 -->
        <div class="col-5 frame5" />
        <div class="col-6 frame6">
          多元繳費系統-退費申請表
        </div>
        <div class="col-1 frame4">
          <barcode
            v-if="CheckBarcode"
            class="printimg"
            v-model="barcode"
            tag="img"
          />
          <br>
        </div>
        <br>
        <div class="col-3 frame2">
          退費單號
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="RefundId"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          申請日期
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="Application"
            placeholder="2019/01/01"
            required
          >
        </div>
        <div class="col-3 frame2">
          申請人(簽名)
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            required
          >
        </div>
        <div class="col-3 frame2">
          退費原因
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="Refund.RefundReason"
            required
          >
        </div>
        <div class="col-3 frame2">
          繳款人
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control nukWord"
            v-model="Refund.UserName"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          退費項目
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="Refund.FeeItemName"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          退費金額
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model.number="Refund.RefundAmt"
            required
          >
        </div>
        <div class="col-3 frame2">
          原繳費金額
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model.number="Refund.PayAmt"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          繳款項目編號
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="Refund.FeeOrderId"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          入帳日期
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="Refund.DebtDate"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          入帳收據號碼
        </div>
        <div class="col-9 frame3">
          <input
            style="text"
            class="form-control"
            v-model="Refund.ReceiptDebt"
            disabled
          >
        </div>
        <div class="col-3 frame2">
          收入傳票日期及編號
        </div>
        <div class="col-9 frame3">
          <span class="ml-2">
            收入傳票編號
          </span>
          <input
            v-model="VoucherNo"
            style="text"
            class="ml-2 ra-input"
            required
          >
          <span class="ml-2">
            收入傳票日期
          </span>
          <input
            v-model="VoucherDate"
            style="text"
            class="ml-2 ra-input"
            required
          >
        </div>
        <div class="col-3 frame2">
          在本校是否已有帳戶資料
        </div>
        <div class="col-9 frame3">
          <div class="form-check form-check-inline ml-2">
            <input
              id="exampleRadios1"
              class="form-check-input"
              name="exampleRadios"
              type="radio"
              style="margin-top: -30px;"
              v-model.number="seletSchoolAccount"
              value="1"
              checked
            >
            <label
              class="form-check-label"
              for="exampleRadios1"
            >
              是 請採購系統已有資料，編號
              <input
                class="ra-input mr-2 ml-2"
                v-model="Refund.SchoolAccount"
                style="text"
              >
              (必填)
              <br>
              註：此編號指請採購系統中之學號、員編、統編、身分證號
            </label>
          </div>
          <div class="form-check form-check-inline ml-2">
            <input
              class="form-check-input"
              type="radio"
              name="exampleRadios"
              id="exampleRadios2"
              v-model.number="seletSchoolAccount"
              value="2"
            >
            <label
              class="form-check-label"
              for="exampleRadios2"
            >
              否 請至請採購系統填寫受款人入帳申請表並檢附下方資料
            </label>
          </div>
        </div>
        <div class="col-3 frame2">
          是否已檢附身份證件
        </div>
        <div class="col-9 frame3">
          <div class="form-check form-check-inline ml-2">
            <input
              class="form-check-input"
              style="margin-top: -30px;"
              type="checkbox"
              value="1"
              id="defaultCheck1"
            >
            <label
              class="form-check-label"
              style="margin-top: -30px;"
              for="defaultCheck1"
            >
              是
            </label>
            <br>
          </div>
        </div>
        <div class="col-3 frame2">
          是否已檢附銀行帳戶存摺影本
        </div>
        <div class="col-9 frame3">
          <div class="form-check form-check-inline ml-2">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="defaultCheck2"
            >
            <label
              class="form-check-label"
              for="defaultCheck2"
            >
              是&ensp;(註：退費帳戶應與繳款人同名)
            </label>
          </div>
        </div>
        <div class="col-3 frame2 signature">
          單位經手人
        </div>
        <div class="col-3 frame3">
          <br>
          <br>
          <br>
        </div>
        <div class="col-3 frame3 signature">
          單位主管
        </div>
        <div class="col-3 frame3">
          <br>
          <br>
          <br>
        </div>
      </div>
      <br>
      <span v-if="CheckOk">
        <v-button
          class="mr-2 no-print"
          btn-text="確認申請"
          btnType="primary"
          v-if="!CheckBarcode"
          @click.native="PostFeeorderRefund"
        />
        <v-button
          class="mr-2 no-print"
          btn-text="列印"
          btnType="warning"
          v-if="CheckBarcode"
          @click.native="print"
        />
      </span>
      <a
        class="btn btn-secondary mr-2 no-print"
        v-if="!CheckBarcode"
        href="#/admin/refund/receipt_report"
        role="button"
      >
        取消
      </a>
      <a
        class="btn btn-secondary mr-2 no-print"
        v-if="CheckBarcode"
        href="#/admin/refund/receipt_report"
        role="button"
      >
        返回
      </a>
      <br>
      <br>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import { apiFeeorderQuerydetail, apiFeeorderRefund, apiFeeorderGetreceipt } from '../../Api/api'

window.addEventListener('DOMContentLoaded', function () { // 生成條碼
  var Vue = window.Vue
  var VueBarcode = window.VueBarcode
  Vue.component('barcode', VueBarcode)
  let vms = new Vue({
    el: '#barcode'
  })
  Vue.use({
    vms
  })
})

export default {
  props: {
    fid: {
      type: String,
      default: ''
    },
    rid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      CheckBarcode: false,
      barcode: '',
      Refund: {},
      RefundId: '',
      Backend: false,
      VoucherNo: '',
      VoucherDate: '',
      Application: '',
      seletSchoolAccount: 0,
      CheckOk: true
    }
  },
  created () {
    this.PostFeeitemQuery()
  },
  methods: {
    PostFeeitemQuery () { // 查詢 B_API 014
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      // 判斷管理&業務(帶部門id)
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) {
        vm.Backend = true
      }
      if (vm.Backend === true) {
        NewData.DeptId = ''
      } else {
        const UserData = JSON.parse(sessionStorage.getItem('UserData'))
        NewData.DeptId = UserData.DeptId
      }
      NewData.FeeItemId = ''
      NewData.FeeOrderId = vm.fid
      NewData.PayDTStart = ''
      NewData.PayDTEnd = ''
      NewData.PayType = null
      NewData.FeeOrderStatus = null
      if (vm.rid === 'check') {
        const dt = new Date()
        this.Application = dt.getFullYear() + '/' + (dt.getMonth() + 1) + '/' + dt.getDate()
      } else {
        vm.CheckBarcode = true
        vm.barcode = vm.rid
      }
      // 呼叫API
      apiFeeorderQuerydetail(NewData).then(
        res => {
          if (res !== undefined) {
            vm.Refund = res.Data[0]
            // 判斷有無帳戶資料
            if (vm.Refund.SchoolAccount !== '') {
              vm.seletSchoolAccount = 1
            }
            vm.PostFeeorderGetreceipt()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeorderRefund () { // 退費申請 B_API 016
      // 定義資料
      var Errortxt = ''
      var patrn = /^[0-9]*$/
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const Data = vm.Refund
      if (Data.RefundReason === '') {
        Errortxt = '請填寫退費原因。'
      }
      if (vm.seletSchoolAccount === 0) {
        Errortxt = '請選擇是否已有帳戶資料。'
      } else {
        if (vm.seletSchoolAccount === 1) {
          if (Data.SchoolAccount === '') {
            Errortxt = '請填寫採購系統編號。'
          }
        }
      }
      if (!patrn.test(Data.RefundAmt)) {
        Errortxt = '退費金額請填寫數字。'
      } else if (Data.RefundAmt > Data.PayAmt) {
        Errortxt = '退費金額不得大於原繳費金額。'
      }
      NewData.RefundReason = Data.RefundReason
      NewData.SchoolAccount = Data.SchoolAccount
      NewData.PayAmt = Data.PayAmt
      NewData.RefundAmt = Data.RefundAmt
      NewData.FeeOrderId = Data.FeeOrderId
      NewData.FeeOrderDesc = Data.FeeOrderDesc
      NewData.DebtDate = Data.DebtDate
      NewData.ReceiptDebt = Data.ReceiptDebt
      NewData.DeptId = UserData.DeptId
      if (Errortxt !== '') {
        vm.ErrorModal(Errortxt)
        return false
      }
      // 呼叫API
      apiFeeorderRefund(NewData).then(
        res => {
          if (res !== undefined) {
            vm.RefundId = res.RefundId
            vm.barcode = vm.RefundId
            vm.PostFeeitemQuery()
            vm.CheckBarcode = true
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeorderGetreceipt () { // 取得收入傳票資訊 B_API 029
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.DeptId = vm.Refund.ApplyDeptId
      NewData.FeeOrderId = vm.Refund.FeeOrderId
      NewData.ReceiptDebt = vm.Refund.ReceiptDebt
      // 呼叫API
      apiFeeorderGetreceipt(NewData).then(
        res => {
          if (res !== undefined) {
            vm.VoucherNo = res.VoucherNo
            vm.VoucherDate = res.VoucherDate
          } else {
            if (vm.rid === 'check') {
              vm.CheckOk = false
            }
            $('#CheckError').modal('show')
          }
        }
      )
    },
    print () { // 列印
      var text = document
      print(text)
    },
    ErrorModal (data) { // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/applicationform.scss';
.ra-right {
  border-right-style: solid;
  border-width:1px;
}
.ra-bottom {
  border-bottom-style: solid;
  border-width:1px;
}
.ra-left {
  border-left-style: solid;
  border-width:1px;
}
.ra-top {
  border-top-style: solid;
  border-width:1px;
}
.ra-margin-top {
  margin-top: 3px;
}
.printimg {
  position: inherit;
  width: 550%;
  right: 430%;
  top: 3%;
  display: block;
}
</style>
